<div class="machine-container">
  <section class="leftbar">
    <app-filter-component
      [selectedMachine]="selectedMachine"
      [listOfMachinesFromApi]="listOfMachinesFromApi"
      (filterByDateChanged)="handleFilterByDateChanged($event)"
      (selectedMachineChanged)="handleSelectedMachineChange($event)"
    >
      ></app-filter-component
    >
  </section>
  <div
    *ngIf="
      selectedMachine && (selectedMachineTotals$ | async)?.count;
      then thenBlock;
      else elseBlock
    "
  ></div>

  <ng-template #thenBlock>
    <section class="rightbar">
      <div
        *ngIf="selectedMachine && dateRange"
        fxLayout="row-reverse"
        class="toolbar"
      >
        <button
          class="csv-download"
          (click)="onDataWorkCsvDownloadClicked()"
          mat-flat-button
          style="margin-left: 10px;"
        >
          <mat-icon>download</mat-icon> Data Works CSV
        </button>
        <button
          *ngIf="shouldShowDataEnergyButton()"
          class="csv-download"
          (click)="onDataEnergyCsvDownloadClicked()"
          mat-flat-button
        >
          <mat-icon>download</mat-icon> Data Energy CSV
        </button>
      </div>
      <div class="machine-chart-section">
        <app-machine-info
          [selectedMachine]="selectedMachine"
          [dateRange]="dateRange"
        ></app-machine-info>
        <div class="charts">
          <app-circular-percentage
            [machineWaitRatio]="machineWaitRatio"
            [machineErrorRatio]="machineErrorRatio"
            [machineRunningRatio]="machineRunningRatio"
            [machineOverallConsumption]="machineOverallConsumption"
            [machinePowerAlgorithm]="machinePowerAlgorithm"
          ></app-circular-percentage>
          <div class="horizontal-line"></div>
          <app-chart-component
            [sumOfJobsChartLabels]="sumOfJobsChartLabels"
            [sumOfJobsChartDataSets]="sumOfJobsChartDataSets"
            [totalCutCreaseChartLabels]="totalCutCreaseChartLabels"
            [totalCutCreaseChartDataSets]="totalCutCreaseChartDataSets"
            (selectedPeriodChanged)="handleChartPeriodChanged($event)"
            [selectedPeriod]="selectedPeriod"
          ></app-chart-component>
        </div>
      </div>
      <div class="total-jobs-section">
        <app-machine-totals
          [selectedMachineTotals$]="selectedMachineTotals$"
        ></app-machine-totals>
        <app-machine-total-jobs
          [machineTotalJobsList]="machineTotalJobsList"
        ></app-machine-total-jobs>
      </div>
    </section>
  </ng-template>
  <ng-template #elseBlock>
    <section>
      <mat-card>
        <mat-card-content>
          no data to display, refine your search criteria or select one of the
          available machines.
        </mat-card-content>
      </mat-card>
    </section>
  </ng-template>
</div>
